import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { IcClose16, IcWheel28 } from '$assets';
import { attachActions } from '$store/attach';
import { useTranslator } from '$hooks';

export const Roulette: FC<{ pickerId: string }> = (props) => {
  const dispatch = useDispatch();
  const t = useTranslator();

  const handleRemove = useCallback(() => {
    dispatch(attachActions.removeRoulette(props.pickerId));
  }, [props.pickerId]);

  return (
    <div className="AttachPickerManager__roulette">
      <div className="AttachPickerManager__roulette__icon">
        <IcWheel28 />
      </div>
      <div className="AttachPickerManager__roulette__title">
        {t('new_post_attach_roulette')}
      </div>
      <div className="AttachPickerManager__roulette__cancel" onClick={handleRemove}>
        <IcClose16 />
      </div>
    </div>
  );
};
